import { render } from "./MainDailyReportByClient.vue?vue&type=template&id=689987d6"
import script from "./MainDailyReportByClient.vue?vue&type=script&lang=js"
export * from "./MainDailyReportByClient.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__